module.exports = __webpack_public_path__ + "static/assets/576da4dfe45a32e69eb362ae00a042bf.svg";